import { Link } from "react-router-dom";
import { channels } from "../../mocks/articles";

export default function Footer() {
  return (
    <footer className="mt-auto bg-background-100 border-t border-background-200">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-12 gap-8">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="flex items-center justify-center w-9 h-9 rounded-lg bg-primary-500 text-background-50 font-bold text-xl font-heading">
                瓜
              </span>
              <div className="leading-none">
                <span className="block font-heading text-lg font-bold text-foreground-950">在线吃瓜</span>
                <span className="block text-[10px] tracking-[0.2em] text-foreground-500 mt-1">深挖 · 吃透</span>
              </div>
            </div>
            <p className="mt-4 max-w-md text-sm leading-7 text-foreground-600">
              一个专注于娱乐深度观察的编辑部：从明星动态、小道消息，到未删细节与隐藏线索的挖掘，再到聚光灯照不到的边角料。
              我们主张理性吃瓜——先辨真假，再下结论。
            </p>
            <p className="mt-3 text-xs text-foreground-500 leading-6">
              本站内容以行业观察与作品分析为主，涉具体人物部分请以官方信息为准，不传播无据谣言。
            </p>
          </div>

          <div className="lg:col-span-3">
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">栏目导航</h4>
            <ul className="space-y-2.5">
              {channels.map((c) => (
                <li key={c.id}>
                  <Link to={`/channel/${c.id}`} className="group inline-flex items-center gap-2 text-sm text-foreground-600 hover:text-primary-700">
                    <span className="w-1 h-1 rounded-full bg-primary-400 group-hover:bg-primary-600"></span>
                    {c.name}
                  </Link>
                </li>
              ))}
              <li>
                <Link to="/" className="group inline-flex items-center gap-2 text-sm text-foreground-600 hover:text-primary-700">
                  <span className="w-1 h-1 rounded-full bg-primary-400 group-hover:bg-primary-600"></span>
                  首页 · 今日热榜
                </Link>
              </li>
            </ul>
          </div>

          <div className="lg:col-span-4">
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">联系编辑部</h4>
            <ul className="space-y-3 text-sm text-foreground-600">
              <li className="flex items-center gap-2.5">
                <i className="ri-mail-line text-primary-500"></i>
                <span className="break-all">tougao@chigua.readdy.site</span>
              </li>
              <li className="flex items-center gap-2.5">
                <i className="ri-question-line text-primary-500"></i>
                <Link to="/about" className="hover:text-primary-700">
                  关于我们 · 投稿说明
                </Link>
              </li>
              <li className="flex items-center gap-2.5">
                <i className="ri-shield-check-line text-primary-500"></i>
                理性吃瓜 · 不信谣不传谣
              </li>
            </ul>
            <div className="mt-5 inline-flex items-center gap-2 rounded-full bg-accent-100 text-accent-900 px-3 py-1.5 text-xs">
              <i className="ri-water-flash-line"></i>
              新瓜速递 · 记得常来看看
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-background-200 bg-background-200/60">
        <div className="mx-auto max-w-7xl px-4 md:px-6 py-4 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-foreground-500">
          <p>© 2026 在线吃瓜 · 深度娱乐观察</p>
          <p className="flex items-center gap-4">
            <span className="hidden sm:inline">在线吃瓜 · 未删细节 · 隐藏线索 · 边角料补充爆料</span>
            <span className="text-primary-600 font-medium">让瓜更透更甜</span>
          </p>
        </div>
      </div>
    </footer>
  );
}